import ApiService from '../services/apiService';

export const createAnnualGratificationSettingsRequest = ({ dispatch, params = {}, failureCallback, successCallback }) =>
  ApiService.request('post', '/annual_gratification_settings', {
    dispatch,
    params,
    failureCallback,
    successCallback,
    service: 'payroll'
  });

export const updateAnnualGratificationSettingsRequest = (
  id,
  { dispatch, params = {}, failureCallback, successCallback }
) =>
  ApiService.request('put', `/annual_gratification_settings/${id}`, {
    dispatch,
    params,
    failureCallback,
    successCallback,
    service: 'payroll'
  });

export const getAnnualGratificationSettingsRequest = ({ dispatch, params = {}, failureCallback, successCallback }) =>
  ApiService.request('get', '/annual_gratification_settings/find_per_year', {
    dispatch,
    params,
    failureCallback,
    successCallback,
    service: 'payroll'
  });
